"use client";

import { cn } from "@/lib/utils/general-utils";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import { forwardRef } from "react";

export function Text({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"p">) {
  return (
    <p
      data-slot="text"
      {...props}
      className={cn(
        "text-base/6 text-muted-foreground sm:text-sm/6",
        className,
      )}
    />
  );
}

export function TextLink({
  className,
  ...props
}: NextLinkProps & React.ComponentPropsWithoutRef<"a">) {
  return (
    <NextLink
      {...props}
      className={cn(
        "text-foreground underline decoration-foreground/50 hover:decoration-foreground",
        className,
      )}
    />
  );
}

export const Strong = forwardRef<
  HTMLElement,
  React.ComponentPropsWithoutRef<"strong">
>(({ className, ...props }, ref) => (
  <strong
    ref={ref}
    {...props}
    className={cn("font-medium text-foreground", className)}
  />
));
Strong.displayName = "Strong";

export function Code({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"code">) {
  return (
    <code
      {...props}
      className={cn(
        "rounded-sm border border-border bg-muted px-0.5 text-sm font-medium text-foreground sm:text-[0.8125rem]",
        className,
      )}
    />
  );
}
